import { HttpErrorResponse } from '@angular/common/http';

export function toError(value: unknown): HttpErrorResponse | Error {
  if (value instanceof HttpErrorResponse) {
    return value;
  }
  if (value instanceof Error) {
    return value;
  }
  if (typeof value === 'string') {
    return new Error(value);
  }
  if (
    value &&
    typeof value === 'object' &&
    'message' in value &&
    typeof value.message === 'string'
  ) {
    return new Error(value.message);
  }
  console.error('Unknown error', value);
  return new Error('Unknown error');
}
